
import React,{useContext, useEffect, useState} from 'react';
import logo from "../img/logo.png";
import "../css/Navbar.css";
import { Link } from 'react-router-dom';
import { LoginContext } from '../context/LoginContext';
import { useNavigate } from 'react-router-dom';

export default function Navbar({login}) {
  const navigate = useNavigate();
  const {setModalOpen} = useContext(LoginContext);
  const [unreadTotal, setUnreadTotal] = useState(0);
  const [notifTotal, setNotifTotal] = useState(0);
  const [followingNew, setFollowingNew] = useState(false);
  const [followingLatestId, setFollowingLatestId] = useState(null);

  const checkFollowingNew = () => {
    const token = localStorage.getItem('jwt');
    if(!token){ setFollowingNew(false); return; }
    fetch('/myfollowingpost', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => {
        if (r.status === 401) { setFollowingNew(false); return null; }
        return r.json();
      })
      .then(list => {
        if (!list) return;
        if (!Array.isArray(list) || list.length === 0) { setFollowingNew(false); return; }
        // determine newest post by createdAt timestamp (server may return unsorted)
        let latest = list[0];
        for (let i = 1; i < list.length; i++) {
          const a = new Date(latest.createdAt || latest.updatedAt || 0).getTime();
          const b = new Date(list[i].createdAt || list[i].updatedAt || 0).getTime();
          if (b > a) latest = list[i];
        }
        const latestId = latest._id;
        setFollowingLatestId(latestId);
        const lastSeen = localStorage.getItem('followingLastSeenId');
        if (!lastSeen) {
          // don't auto-mark as seen when the user simply loads data — show badge
          setFollowingNew(true);
        } else {
          setFollowingNew(latestId !== lastSeen);
        }
      }).catch(()=>{});
  }

  const refreshUnread = () => {
    // prefer local cache for instant UI update
    const map = window.__unreadCounts || {};
    const total = Object.values(map).reduce((s, v) => s + (v || 0), 0);
    setUnreadTotal(total);

    // notifications count from cache first
    const cached = window.__notifCount || 0;
    if (cached !== notifTotal) {
      setNotifTotal(cached);
    }

    // also fetch from server periodically to correct drift
    const token = localStorage.getItem('jwt');
    if (!token) return;
    fetch('/conversations/unread', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(list => {
        const srvTotal = (list || []).reduce((s, it) => s + (it.count || 0), 0);
        if (srvTotal !== total) setUnreadTotal(srvTotal);
      }).catch(()=>{});

    // notifications count from server
    fetch('/notifications', { headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') } })
      .then(r => r.json())
      .then(list => {
        const count = (list || []).filter(n => !n.read).length;
        setNotifTotal(count);
        window.__notifCount = count;
      }).catch(()=>{});
  }

  useEffect(() => {
    refreshUnread();
    checkFollowingNew();
    const handler = () => refreshUnread();
    window.addEventListener('unread-updated', handler);
    window.addEventListener('notif-updated', handler);
    window.addEventListener('user-changed', checkFollowingNew);
    return () => {
      window.removeEventListener('unread-updated', handler);
      window.removeEventListener('notif-updated', handler);
      window.removeEventListener('user-changed', checkFollowingNew);
    };
  }, []);

  const loginStatus = ()=>{
    const token = localStorage.getItem("jwt")
    if(login || token){
      return [
        <>
        <Link style={{marginRight:"20px"}} to="/explore">Explore</Link>
        <Link style={{marginRight:"20px"}} to="/search">Search Users</Link>
        <Link style={{marginRight:"20px", position:'relative'}} to="/notifications">Notifications
          {notifTotal > 0 && <span style={{background:'red',color:'#fff',borderRadius:12,padding:'2px 6px',fontSize:12,marginLeft:6,position:'absolute',top:-8,right:-24}}>{notifTotal}</span>}
        </Link>
        <Link style={{marginRight:"20px"}} to="/createPost">Create Post</Link>
        <Link style={{marginRight:"20px"}} to="profile"><li>Profile</li></Link>
        <Link
          style={{marginRight:"20px", position:'relative'}}
          to="/followingpost"
          onClick={() => {
            try{
              if(followingLatestId){
                localStorage.setItem('followingLastSeenId', followingLatestId);
              } else {
                localStorage.setItem('followingLastSeenId', '');
              }
            }catch(e){}
            setFollowingNew(false);
          }}
        >
          <li style={{position:'relative', display:'inline-block'}}>
            <span class="material-symbols-outlined">group</span>
            {followingNew && <span style={{background:'red',display:'inline-block',width:12,height:12,borderRadius:12,position:'absolute',top:-6,right:-6}}></span>}
          </li>
        </Link>
        <Link style={{marginRight:"20px", position:'relative'}} to="/chatpage">Chat
          {unreadTotal > 0 && <span style={{background:'red',color:'#fff',borderRadius:12,padding:'2px 6px',fontSize:12,marginLeft:6,position:'absolute',top:-8,right:-24}}>{unreadTotal}</span>}
        </Link>
        <Link to={""}>
          <button className='primaryBtn' onClick={()=> setModalOpen(true)}>
            Log Out
          </button>
        </Link>
        </>
      ]
    }else{
      return [
        <>
        <Link to="signup">
            <li>SignUp</li>
        </Link>
        <Link to="signin">
            <li>SignIn</li>
        </Link>
        </>
      ]
    }
  };
  const loginStatusMobile =()=>{
      const token = localStorage.getItem("jwt")
      if(login || token){
        return [
          <>
          <Link to="/">
              <li><span class="material-symbols-outlined">
                cottage
                </span></li>
          </Link>
          {/* search replaced by notifications */}
          <Link to="/notifications" style={{position:'relative'}}>
            <li style={{position:'relative', display:'inline-block'}}>
              <span class="material-symbols-outlined">notifications</span>
              {notifTotal > 0 && <span style={{background:'red',color:'#fff',borderRadius:12,padding:'2px 6px',fontSize:10,position:'absolute',top:'-8px',right:'-8px', minWidth:'18px', textAlign:'center'}}>{notifTotal}</span>}
            </li>
          </Link>
          <Link to="/createPost">
            <li><span class="material-symbols-outlined">photo_camera</span></li>
          </Link>
          
          <Link to="/profile">
              <li><span class="material-symbols-outlined">account_circle</span></li>
          </Link>

          {/* My Following moved to top navbar for mobile layout */}

          <Link to="/chatpage" style={{position:'relative'}}>
              <li style={{position:'relative', display:'inline-block'}}>
                <span id='sendIcon' class="material-symbols-outlined">send</span>
                {unreadTotal > 0 && <span style={{background:'red',color:'#fff',borderRadius:12,padding:'2px 6px',fontSize:10,position:'absolute',top:'-8px',right:'-8px', minWidth:'18px', textAlign:'center'}}>{unreadTotal}</span>}
              </li>
          </Link>

          </>
        ]
      }else{
        return [
          <>
          <Link to="signup">
              <li>SignUp</li>
          </Link>
          <Link to="signin">
              <li>SignIn</li>
          </Link>
          </>
        ]
      
    };
  }
  
  return (
  <div className="navbar">
    <img id='linkalikes-logo' src={logo} alt="" onClick={()=>{navigate("/")}} style={{cursor:"pointer"}} />
    <ul className='nav-menu'>{loginStatus()}</ul>
    <ul className='nav-mobile'>{loginStatusMobile()}</ul>
  </div>
  );
}
